/* eslint-disable react/display-name */
import React from "react";
import LineIndicator from "../../components/dashboard/Crypto/LineIndicator";
import { getSubjectByName } from "../../constants/AppConstants";
export const chapter_progress_columns = [
  {
    dataIndex: 'title',
    key: 'title',
    render: (text, item) => {
      const thisSubject = getSubjectByName(item.subjectname)
      const {total_assignments = 0} = item;
      let coverage = !total_assignments || 0;
      coverage = total_assignments >= 3 || 100;
      coverage =  ((total_assignments<=3?total_assignments:3) * 100 / 3).toFixed(0);
      return (
        <LineIndicator width={`${coverage}%`} title={text} title2={`${total_assignments} assignments assigned`} color={`${thisSubject.color}`} value={`${coverage}%`} />
      )
    },
  }
];